import { message, Select, Switch } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  ButtonItem,
  InputItem,
  InputNumberItem,
  ErrorItem,
  SelectItem,
  SelectTiposAcumuladosItem,
} from "../../../../Components/Items";

const { Option } = Select;

class EditarTipoIncidencia extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    visible: this.props.visible,
    tipo: null,
    derechoSueldo: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.setState({ visible: this.props.visible });
      if (this.props.visible && this.props.tipoIncidenciaId) {
        this.formRef.current && this.formRef.current.resetFields();
        this.setState({ tipo: null, derechoSueldo: false });
        this.consultarDatosTipoIncidencia(this.props.tipoIncidenciaId);
      }
    }
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  consultarDatosTipoIncidencia(id) {
    this.setState({ loading: true });
    axios
      .post(
        "tiposIncidencias/datosTipoIncidencia",
        { tipoIncidenciaId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          message.error("No se encontraron los datos del tipo de incidencia");
        } else {
          const {
            clave,
            nombre,
            tipo,
            valorUnidad,
            derechoSueldo,
            porcentaje,
            disminuyeSeptimo,
            seConsidera,
            esVacaciones,
            esPrimaDominical,
            claveTipoHorasSat,
            tiposAcumulados,
          } = res.data.data;

          this.setState({ tipo, derechoSueldo: !!derechoSueldo });

          this.formRef.current && this.formRef.current.setFieldsValue({
            clave,
            nombre,
            tipo,
            valorUnidad,
            derechoSueldo: !!derechoSueldo,
            porcentaje,
            disminuyeSeptimo: !!disminuyeSeptimo,
            seConsidera,
            esVacaciones: !!esVacaciones,
            esPrimaDominical: !!esPrimaDominical,
            claveTipoHorasSat,
            tiposAcumulados,
          });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  }

  onTipoChange(value) {
    this.setState({ tipo: value });
    if (value === 1) {
      this.formRef.current.setFieldsValue({
        derechoSueldo: false,
        porcentaje: undefined,
        disminuyeSeptimo: false,
        seConsidera: undefined,
        claveTipoHorasSat: undefined,
      });
      this.setState({ derechoSueldo: false });
    } else if (value === 2) {
      this.formRef.current.setFieldsValue({ valorUnidad: undefined, claveTipoHorasSat: undefined });
    } else if (value === 3) {
      this.formRef.current.setFieldsValue({
        valorUnidad: undefined,
        disminuyeSeptimo: false,
        seConsidera: undefined,
      });
    }
  }

  onDerechoSueldoChange(checked) {
    this.setState({ derechoSueldo: checked });
    if (!checked) {
      this.formRef.current.setFieldsValue({ porcentaje: undefined });
    }
  }

  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "tiposIncidencias/editarTipoIncidencia",
        {
          ...values,
          tipoIncidenciaId: this.props.tipoIncidenciaId,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Tipo de incidencia actualizado exitosamente");
          this.cerrarModal();
        } else {
          message.error("No se pudo actualizar el tipo de incidencia");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  }

  cerrarModal = () => {
    this.props.cerrarEditarTipoIncidencia();
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
    this.setState({ tipo: null, derechoSueldo: false });
  };

  render() {
    const { tipo, derechoSueldo } = this.state;

    const esDestajo = tipo === 1;
    const esDias = tipo === 2;
    const esHoras = tipo === 3;

    const deshabilitarValorUnidad = esDias || esHoras;
    const deshabilitarDerechoSueldo = esDestajo;
    const deshabilitarPorcentaje = esDestajo || !derechoSueldo;
    const deshabilitarDisminuyeSeptimo = esDestajo || esHoras;
    const deshabilitarSeConsidera = esDestajo || esHoras;

    return (
      <ModalItem
        title="Editar Tipo de Incidencia"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarModal}
        width={700}
      >
        <Form
          ref={this.formRef}
          name="modalEditarTipoIncidencia"
          layout
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
              loading={this.state.loading}
            >
              Guardar
            </ButtonItem>
          }
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormItem name="clave" label="Clave" required margin>
            <InputItem placeholder="Ingresa la clave" />
          </FormItem>

          <FormItem name="nombre" label="Nombre" margin>
            <InputItem placeholder="Ingresa el nombre del tipo de incidencia" />
          </FormItem>

          <FormItem name="tipo" label="Tipo" required margin>
            <SelectItem
              placeholder="Selecciona el tipo"
              onChange={this.onTipoChange.bind(this)}
            >
              <Option value={1}>Destajo</Option>
              <Option value={2}>Días</Option>
              <Option value={3}>Horas</Option>
            </SelectItem>
          </FormItem>

          <FormItem
            name="valorUnidad"
            label="Valor Unidad"
            margin
            tooltip={deshabilitarValorUnidad ? "No aplica para el tipo seleccionado" : undefined}
          >
            <InputNumberItem
              placeholder="Ingresa el valor por unidad"
              disabled={deshabilitarValorUnidad}
              min={0}
            />
          </FormItem>

          <FormItem
            name="derechoSueldo"
            label="Derecho a Sueldo"
            margin
            valuePropName="checked"
            tooltip={deshabilitarDerechoSueldo ? "No aplica para Destajo" : undefined}
          >
            <Switch
              disabled={deshabilitarDerechoSueldo}
              onChange={this.onDerechoSueldoChange.bind(this)}
            />
          </FormItem>

          <FormItem
            name="porcentaje"
            label="Porcentaje"
            margin
            tooltip={deshabilitarPorcentaje ? (!derechoSueldo && !esDestajo ? "Activa Derecho a Sueldo para habilitar" : "No aplica para el tipo seleccionado") : undefined}
          >
            <InputNumberItem
              placeholder="Ingresa el porcentaje"
              disabled={deshabilitarPorcentaje}
              min={0}
              max={100}
            />
          </FormItem>

          <FormItem
            name="disminuyeSeptimo"
            label="Disminuye del Séptimo Día"
            margin
            valuePropName="checked"
            tooltip={deshabilitarDisminuyeSeptimo ? "No aplica para el tipo seleccionado" : undefined}
          >
            <Switch disabled={deshabilitarDisminuyeSeptimo} />
          </FormItem>

          <FormItem
            name="seConsidera"
            label="Se Considera"
            margin
            tooltip={deshabilitarSeConsidera ? "No aplica para el tipo seleccionado" : undefined}
          >
            <SelectItem
              placeholder="Selecciona cómo se considera"
              disabled={deshabilitarSeConsidera}
            >
              <Option value={1}>Ninguno</Option>
              <Option value={2}>Ausencia</Option>
              <Option value={3}>Incapacidad</Option>
              <Option value={4}>Vacaciones</Option>
            </SelectItem>
          </FormItem>

          <FormItem
            name="esVacaciones"
            label="Es Vacaciones"
            margin
            valuePropName="checked"
            tooltip="Marca el tipo de incidencia que la nómina usa para las vacaciones. Si no lo marcas, el cálculo toma el que tenga Se Considera = Vacaciones."
          >
            <Switch />
          </FormItem>

          <FormItem
            name="esPrimaDominical"
            label="Es Prima Dominical"
            margin
            valuePropName="checked"
            tooltip="Marca el tipo con el que registras los domingos laborados. La nómina cuenta esos días para la prima dominical (25% del salario diario) y para su exención de 1 UMA por domingo. Sin este marcador la exención sale en cero y el pago grava completo."
          >
            <Switch />
          </FormItem>

          <FormItem
            name="claveTipoHorasSat"
            label="Tipo de Horas Extra (SAT)"
            margin
            tooltip={!esHoras ? "Solo aplica para el tipo Horas" : "Clasifica esta incidencia para el nodo HorasExtra del CFDI de nómina"}
          >
            <SelectItem
              placeholder="No es horas extra"
              disabled={!esHoras}
              allowClear
            >
              <Option value="01">Simples</Option>
              <Option value="02">Dobles</Option>
              <Option value="03">Triples</Option>
            </SelectItem>
          </FormItem>

          <FormItem name="tiposAcumulados" label="Tipos de Acumulados" margin>
            <SelectTiposAcumuladosItem
              mode="multiple"
              placeholder="Selecciona los tipos de acumulados"
              empresaId={this.props.empresaId}
              headersToken={this.props.headersToken}
              onChange={(value) => {
                this.formRef.current.setFieldsValue({ tiposAcumulados: value });
              }}
            />
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(EditarTipoIncidencia);